import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { ActivityLogModel } from '../models/activity-log.model';
import { ConfigurationService } from '../shared/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesLogsService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);


  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.activityLogsApiUrl}api/Activities`;
  }
  
  get(taskId: Guid): Observable<Array<ActivityLogModel>> {
    return this.http.get<Array<ActivityLogModel>>(`${this.backUrl}?taskId=${taskId.toString()}`);
  }
  
}
